import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async (data) => {
  return await dponetAPI.postForm('/monitoring_management_kpis', {
    monitoringManagementKpi: data,
  })
}

const list = async (params) => {
  return await dponetAPI.get('/monitoring_management_kpis', {
    params,
  })
}
const show = async ({ monitoringManagementKpiId = '', ...params }) => {
  return await dponetAPI.get(
    `/monitoring_management_kpis/${monitoringManagementKpiId}`,
    {
      params,
    },
  )
}

const update = async ({ monitoringManagementKpiId = '', ...params }) => {
  return await dponetAPI.putForm(
    `/monitoring_management_kpis/${monitoringManagementKpiId}`,
    {
      monitoringManagementKpi: params,
    },
  )
}

const destroy = async ({ monitoringManagementKpiId = '' }) => {
  return await dponetAPI.delete(
    `/monitoring_management_kpis/${monitoringManagementKpiId}`,
  )
}

const destroyAttachment = async ({
  monitoringManagementKpiId = '',
  attachmentId = '',
}) => {
  return await dponetAPI.delete(
    `/monitoring_management_kpis/${monitoringManagementKpiId}/attachment/${attachmentId}`,
  )
}

export default {
  create,
  destroy,
  destroyAttachment,
  list,
  show,
  update,
}
